import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';

import * as _ from 'lodash-es';

import { StateService } from '@uirouter/angular';
import { UploadService } from '../../../services/core.upload.service';
import { createUnixNameFieldDefinition, ProjectService } from '../../../services/project.service';
import { GfTranslateService } from '../../../services/core.translate.service';
import { UiService } from '../../../services/core.ui.service';
import { SnapshotService } from '../../../services/core.snapshot.service';
import { GfTitleService } from '../../../services/core.title.service';
import { doPromiseAll } from '../../../config/core.promise-utils';

@Component({
    selector: 'admin-snapshots-view',
    template: require('./admin.snapshots.component.html')
})
export class AdminSnapshotsViewComponent implements OnInit {

    protected import: { unixName: string; unixNameValid: boolean; snapshot: any } = {
        unixName: '',
        unixNameValid: true,
        snapshot: false
    };

    protected delete: any = {
        snapshot: false,
        deleting: false
    };

    protected importSnapshotForm: UntypedFormGroup = null;

    protected filter: string = '';
    protected snapshots: any = false;
    private requests: any = false;
    private stateParams: any = {};
    protected snapshotUpload: any = false;
    private forceReload = false;
    private uploadSuccess = false;

    constructor(
        private fb: UntypedFormBuilder,
        private stateService: StateService,
        
        private uploadService: UploadService,
        private http: HttpClient,
        private $window: Window,
        private snapshotService: SnapshotService,
        private uiService: UiService,
        private gfTranslateService: GfTranslateService,
        private projectService: ProjectService,
        private titleService: GfTitleService,
    ) {
        this.stateParams = this.stateService.params;
    }
    
    ngOnInit() {
        this.importSnapshotForm = this.fb.group({
            unixName: createUnixNameFieldDefinition(this.projectService),
        });

        this.titleService.setTitle('Site Admin', 'Snapshots');

        this.filter = this.stateParams?.q ?? null;
        this.snapshots = false;

        this.doRefresh();
    };

    doRefresh() {
        this.snapshots = false;
        this.requests = false;

        const snapsParams: any = _.pick(
            this.stateParams, 
            ['q', 'unixName', 'page_num', 'page_size']
        );

        const requestsParams: any = {
            unixName: 0,
            q: this.filter
        };

        const promiseMap =             {
            snapshots: this.snapshotService.listAll(snapsParams),
            requests: this.snapshotService.listAll(requestsParams)
        };

        doPromiseAll(promiseMap).then(
            (map) => {
                this.snapshots = _.get(map, 'snapshots.items', []);
                this.requests = _.get(map, 'requests.items', []);
            },
            (err) => {
                this.snapshots = [];
                this.requests = [];
                console.log(err);
            }
        );
    };

    updatePaging(paging) {
        this.stateService.go('.', paging, { notify: true });
    }

    updateFilter() {
        this.stateService.go('.', { q: this.filter, page_num: 1 }, { notify: true });
    };
    protected updateFilterDebounced = _.debounce(this.updateFilter, 500);

    checkDeleteSnapshot(sn) {
        this.delete.snapshot = sn;
        ($('#deleteSnapshotModal') as any).modal('show');
    };

    doDeleteSnapshot() {
        var id = _.get(this, 'delete.snapshot.id', false);
        if (!id) return;

        this.delete.deleting = true;

        this.snapshotService.delete(id)
        .then(
            (response) => {
                if (_.get(response, 'succeeded', false)) {
                    this.uiService.message.showSuccess(
                        this.gfTranslateService.translate(
                            'Snapshot {{id}} was deleted',
                            { 'id': id }
                        ),
                        id
                    );

                } else {
                    this.uiService.message.showWarning(
                        this.gfTranslateService.translate(
                            'The snapshot file was NOT deleted.  Permission was denied by the server.',
                            { 'id': id }
                        ),
                        id
                    );
                }
                this.doRefresh();
            },
            () => {
                var msg = this.gfTranslateService.translate(
                    'Sorry, could not delete {{id}}.  An error occurred.',
                    { 'id': id }
                );
                this.uiService.message.showWarning(msg, 'Delete Error');
            }
        ).finally(() => {
            this.delete.snapshot = false;
            this.delete.deleting = false;
            // $('#deleteSnapshotModal').modal('hide');
            // $('#deleteSnapshotModal').modal('destroy');
        });
    };

    uploadSnapshot($event) {
        const files = $event.target?.files || [];

        if (!files.length) {
            return;
        }

        this.snapshotUpload = {
            fileName: files[0].name,
            size: files[0].size,
            date: files[0].lastModifiedDate,
            amountComplete: 0,
            amountTotal: files[0].size,
            percentComplete: 0,
            percentRemaining: 100
        };

        var options = {
            successCallback: this.finishUpload,
            progressCallback: this.progressCallback,
            failureCallback: this.failureCallback
        };

        this.uploadService.uploadFiles('snapshot', 0, files, options);
    };

    checkUniqueunixName() {
        this.projectService.fetch({ unixName: this.import.unixName })
            .then((res) => {
                this.import.unixNameValid = (!_.has(res, 'unixName'));
            }, (res) => {
                // 404 Not found means available
                this.import.unixNameValid = (res.status == 404);
            });
    };

    doImportSnapshot() {
        this.snapshotService.postImport(_.get(this.import.snapshot, 'id', 0), this.import.unixName).then(
            (result) => {
                this.uiService.message.showSuccess(
                    this.gfTranslateService.translate("The import has been requested.  You will see further notifications when the import is complete."),
                    this.gfTranslateService.translate("Import Snapshot")
                );
            },
            (result) => {
                console.log(result);
                this.uiService.message.showWarning(
                    this.gfTranslateService.translate("The import could not be started.  Check the system logs for more information."),
                    this.gfTranslateService.translate("Import Snapshot")
                );
            }
        );
    };

    finishUpload = (section, refId, file, hash) => {

        this.forceReload = true;

        this.http.post(
            '/api/snapshot/0/create/' + hash,
            { file: file.name }
        ).toPromise()
        .then(
            () => {
                this.uiService.message.showSuccess("Finished uploading " + file.name, "Upload Snapshot");
                this.uploadSuccess = true;
            },
            (response) => {
                console.log(response);
                this.uiService.message.showError("Failed to upload the snapshot file");
            }
        ).finally(() => {
            this.snapshotUpload = false;
            this.doRefresh();
        });
    }

    failureCallback = (section, refId, file, err) => {
        this.snapshotUpload = false;
    }

    progressCallback = (section, refId, file, bytesUploaded, bytesRemaining, percentUploaded, percentRemaining) => {
        this.snapshotUpload.amountComplete = bytesUploaded;
        this.snapshotUpload.amountTotal = bytesRemaining;
        this.snapshotUpload.percentComplete = percentUploaded;
        this.snapshotUpload.percentRemaining = percentRemaining;
    }
}
